import type { SiteEntity } from '../types/site';
import type { SiteRagReport } from '../types/siteRag';

export interface SupplyChainFreshness {
  stale: boolean;
  generatedAtLabel?: string;
  liveAtLabel?: string;
}

function toEpoch(iso: string | undefined): number | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  return Number.isFinite(t) ? t : null;
}

/**
 * Hybrid freshness for Supply Chain Risk reports:
 * report generation is always manual, but the report is marked stale when
 * live BoM/supplier/quote state has changed after generation.
 */
export function getSupplyChainFreshness(
  report: SiteRagReport | undefined,
  site: Pick<SiteEntity, 'supplyChainPlan'> | null | undefined,
): SupplyChainFreshness {
  if (!report || report.reportType !== 'supply-chain-risk') return { stale: false };
  const generatedAt = toEpoch(report.supplyChainPlanAtGen?.updatedAt);
  const liveAt = toEpoch(site?.supplyChainPlan?.updatedAt);
  if (generatedAt == null || liveAt == null) return { stale: false };
  if (liveAt <= generatedAt) return { stale: false };
  return {
    stale: true,
    generatedAtLabel: report.supplyChainPlanAtGen?.updatedAt,
    liveAtLabel: site?.supplyChainPlan?.updatedAt,
  };
}
